import React from 'react';

import { Col, Cols, Row, Rows, Text } from '~/src/dash/publicaUI';
import { useSandboxStore } from '~/src/dash/views/sandbox/contexts';

export const GeneralLayoutProps = () => {
  const { cfg } = useSandboxStore();
  return (
    <Cols>
      <Col flex>
        <Rows verticalPadding>
          <Row>
            <Text subheader>General Layout Props</Text>
            <Text small muted>
              These are available in Panels, Panel, Rows, Row, Cols, Col.
            </Text>
          </Row>
          {cfg.layout.globalProps.map((prop: Record<string, string>) => (
            <Row noVerticalPadding>
              <Cols>
                <Col width={256}>
                  <Text bold>{prop.prop}</Text>
                </Col>
                <Col>
                  <Text highlighted>{prop.valueType}</Text>
                </Col>
              </Cols>
            </Row>
          ))}
        </Rows>
      </Col>
      <Col flex>
        <Rows verticalPadding>
          <Row>
            <Text subheader>Spacing Values</Text>
            <Text small muted>
              Values are strings. (ex. spacing.small = '8px')
            </Text>
          </Row>
          {cfg.spacing.map((item: Record<string, string>) => (
            <Row noVerticalPadding>
              <Cols>
                <Col width={128}>
                  <Text bold>{item.slug}</Text>
                </Col>
                <Col>
                  <Text highlighted>{item.value}</Text>
                </Col>
              </Cols>
            </Row>
          ))}
        </Rows>
      </Col>
    </Cols>
  );
};
